import React from "react";
import "../styles/components/flyByButtonBar.css";

/**
 * Container für EAFlyByButton Komponenten.
 * @param id
 * @param children
 * @returns {JSX.Element}
 * @constructor
 */
function EAFlyByButtonBar({ id, children }) {
    return (
        <div id={id} className="flyByButtonBar">
            {children}
        </div>
    );
}

export default EAFlyByButtonBar;
